module.exports = __webpack_public_path__ + "static/media/map_pin_int_near.5f947a1a.svg";